<template>
  <div class="app-container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="待我处理" name="first">
        <may v-if="activeName === 'first'"></may>
      </el-tab-pane>
      <el-tab-pane label="我处理的" name="second">
        <me v-if="activeName === 'second'"></me>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import may from './mayStay'
import me from './stayMy'
export default {
  components: {
    may,
    me
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style></style>
